import React, { useMemo } from "react";
import { Modal } from "react-bootstrap";
import { Sun, Moon } from "react-feather";
import EmployeeAvatar from "../../reports/oneStop/components/EmployeeAvatar";
import { useEmployeePhotoCache } from "../../masters/employees/useEmployeePhotoCache";

/**
 * One guard's month - the WinForms double-click on a Duty List cell
 * (frm_Emp_assignment_details): every day they were on duty, where, which
 * shift. Built from the rows already loaded, so it covers the same branch,
 * month and filters as the page.
 */
const GuardMonthModal = ({ guard, monthText, onClose }) => {
  const photoUrls = useEmployeePhotoCache(useMemo(() => (guard ? [guard] : []), [guard]));
  if (!guard) return null;
  const byDay = new Map();
  guard.days.forEach((d) => byDay.set(d.day, [...(byDay.get(d.day) || []), d]));

  return (
    <Modal show onHide={onClose} size="lg" centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title className="h5 d-flex align-items-center">
          <span className="me-2">
            <EmployeeAvatar name={guard.name} photoUrl={photoUrls[guard.employeeRecordGuid]} size="lg" />
          </span>
          <span className="text-primary fw-bold me-2">{guard.empCode}</span>
          {guard.name || "(not in employee master)"}
          <span className="text-muted ms-2 fs-6">{monthText}</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex flex-wrap gap-3 mb-3 small">
          <span>
            <Sun size={13} className="me-1 text-warning" />
            {guard.dayShifts} Day
          </span>
          <span>
            <Moon size={13} className="me-1 text-primary" />
            {guard.nightShifts} Night
          </span>
          <span className="fw-semibold">{guard.total} shifts</span>
          <span className="text-muted">{guard.customerCount} customer{guard.customerCount === 1 ? "" : "s"}</span>
        </div>
        <table className="table table-sm duty-table mb-0">
          <thead>
            <tr>
              <th>Day</th>
              <th>Shift</th>
              <th>Customer</th>
              <th>Assignment</th>
              <th>Area</th>
            </tr>
          </thead>
          <tbody>
            {[...byDay.entries()].map(([day, entries]) =>
              entries.map((e, i) => (
                <tr key={`${day}-${i}`} className={entries.length > 1 ? "table-warning" : undefined}>
                  <td className="fw-semibold">{i === 0 ? day : ""}</td>
                  <td>
                    {e.shift}
                    {e.web !== undefined && <span className="badge bg-success ms-1" title="Marked on the web">web{e.web ? ` ${e.web}` : ""}</span>}
                  </td>
                  <td>{e.custName}</td>
                  <td>{e.assignmentName}</td>
                  <td>{e.area}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </Modal.Body>
    </Modal>
  );
};

export default GuardMonthModal;
